<template>
  <div class="english-container">
    <h2>Descripción del producto</h2>
    <p  style="text-align: left;" >Compartimos su entusiasmo por Wireless tag, un dispositivo de localización para Android diseñado para integrarse perfectamente con la aplicación Find Hub de Google y ayudarle a localizar sus objetos con la ayuda de miles de millones de dispositivos Android en todo el mundo
</p>
  
    <p  style="text-align: left;" >Wireless tag es un dispositivo de localización inteligente que utiliza el servicio Google Find Hub y se vincula con la aplicación “Find Hub” en dispositivos Android para localizar sus objetos personales de forma rápida y segura mediante Google Maps. Toda la información de ubicación permanece privada y ni siquiera Google puede acceder a ella.
</p>

<h3> 1. Iniciar sesión en la aplicación Find Hub</h3>
  <ol>
    <li>Vaya a Google Play y busque 'Find Hub'.</li>
    <li>Instale la aplicación o haga clic en "Actualizar'.</li>
    <li> Pulse 'Abrir' o haga clic en el icono de la aplicación Find Hub en la pantalla de inicio de su teléfono</li>
    <li>Inicie sesión en la página de Find Hub con su cuenta de Google. Puede seleccionar la casilla que dice No volver a preguntar'.
Si tiene más de una cuenta, su objeto se vinculará a la cuenta principal configurada en su teléfono.</li>
    <li>Es posible que se le solicite conceder algunos permisos. Revise los términos y continúe
</li>
  </ol>

  <h3>2. Encendido</h3>
  <p style="text-align: left;">
    <strong> Encendido: </strong> Mantenga presionado durante 3 segundos el punto circular del botón de encendido del dispositivo. Cuando escuche un sonido de timbre, significa que el dispositivo se ha encendido. (Consulte el diagrama)
  </p>

   <img src="../assets/gid_1.png" alt="Wireless Tag Logo" class="image_1" />

<h3>3. Conectar a la aplicación Find Hub</h3>
  
      <p style="text-align: left;">
        3.1 Asegúrese de que el Bluetooth de su teléfono esté activado y de que esté conectado a Internet.
      </p>
 <p style="text-align: left;">
  3.2 Acerque su tag al teléfono y espere a que aparezca la ventana emergente de Wireless tag. En la parte inferior de la ventana emergente, pulse 'Conectar'. Lea y acepte las indicaciones para completar la vinculación
</p>

<h3>4.Introducción del producto</h3>
<h4>4.1 Búsqueda de objetos cercanos</h4>
<p style="text-align: left;">
  4.1.1 A veces está más cerca de su objeto perdido de lo que cree. Si sabe que se encuentra en algún lugar de la casa, Find Hub indicará la intensidad de su señal para ayudarle a localizarlo
</p>
<p style="text-align: left;">
  4.1.2 Si su dispositivo se encuentra dentro del alcance de la señal inalámbrica, seleccione su dispositivo en la aplicación “Find Hub” y toque “Reproducir sonido” para localizarlo. Una vez encontrado, toque “Detener sonido” para silenciar el dispositivo.
</p>
<p style="text-align: left;">
  4.1.3 El Asistente de Google en su Google Home o Pixel Watch está aquí para ayudarle. Pruebe comandos como “Hey Google, busca mi cartera” o “Hey Google, busca mis llaves” para encontrar rápidamente sus objetos.

</p>
<h4>4.2 Una comunidad para encontrar objetos</h4>
  <p style="text-align: left;">
   Cuando se encuentre realmente lejos de un objeto, la red Find Hub está aquí para ayudarle. Los dispositivos Android de todo el mundo, como tablets, teléfonos y ordenadores portátiles, colaborarán para ayudarle a encontrar sus objetos perdidos.
</p>
<h4>4.3 Activar el modo perdido</h4>
 <p style="text-align: left;">
  Cuando pierda su objeto, seleccione el dispositivo en la aplicación “Find Hub” y toque “Marcar como perdido”. Recibirá una notificación cuando la ubicación esté disponible. Puede dejar sus datos de contacto para que la persona que encuentre su objeto pueda ponerse en contacto con usted.
  </p>

  <h4>4.4 Compartir ubicación</h4>

   <p style="text-align: left;">
Seleccione el dispositivo en la aplicación “Find Hub” y toque “Compartir dispositivo”. Después de que el propietario del accesorio confirme el uso compartido, el accesorio aparecerá en la lista de la aplicación Find Hub. Ambas cuentas podrán ver las actualizaciones de ubicación y podrán hacer sonar el dispositivo localmente.
  </p>

  <h4>4.5 Alertas de rastreador desconocido</h4>
   <p style="text-align: left;">
Su seguridad es lo primero. Find Hub está diseñado para evitar el seguimiento no deseado. Si su teléfono Android detecta un dispositivo desconocido que se mueve con usted, recibirá una notificación. Vea el dispositivo desconocido en un mapa, hágalo sonar para localizarlo o solicite más ayuda.
  </p>

  <h4>4.6 Privacidad</h4>
   <p style="text-align: left;">
Sus datos de ubicación están cifrados de extremo a extremo, lo que significa que Google nunca puede verlos ni acceder a ellos. Solo usted puede ver dónde han estado y dónde se encuentran actualmente sus objetos. Con la aplicación Find Hub, Google no utiliza ni comparte sus datos. La información que comparte sobre usted y sus dispositivos permanece confidencial.
  </p>
  
 <h3>5. Reemplazo de la batería</h3>
  <p style="text-align: left;">
      5.1 Inserte la herramienta de apertura en la ranura de la carcasa.
  </p>

   <p style="text-align: left;">
      5.2 Gire la herramienta de apertura de la carcasa 90 grados para abrirla.
  </p>

   <p style="text-align: left;">
      5.3 Use las uñas en la pequeña ranura lateral de su Locator para abrir cuidadosamente la carcasa.
  </p>

   <p style="text-align: left;">
      5.4 Reemplace la batería por una nueva CR2032 de 3 V (el polo positivo con el texto hacia arriba).
  </p>

     <img src="../assets/open_tag.png" alt="Wireless Tag Logo" class="image_1" />

  <h3>6. Funciones del botón</h3>
  <ol>
    <li style="text-align: left;">
      Encendido (la función Find My está activada)
      <p>
        Mantenga presionado el botón de función durante 3 segundos para encenderlo. Emitirá un sonido de timbre que indica que está encendido. Si el producto no está vinculado a su cuenta de Google, se apagará automáticamente después de 10 minutos. Deberá activar nuevamente la función Find My para continuar con la vinculación.
        </p>
    </li>
    <li style="text-align: left;">Apagado (la función Find My está desactivada).
      <p>
        Mantenga presionado el botón de función durante tres segundos y luego <strong>suéltelo...</strong>. Escuchará dos pitidos que indican que está apagado.
      </p>
    </li>
    <strong  style="text-align: left;">
      <p>Nota:</p>
      <p>1. Si lo presiona durante menos de 3 segundos o más de 5 segundos, el dispositivo no se apagará</p>
      <p>2. La configuración de un temporizador de apagado está diseñada para evitar apagados accidentales y garantizar que el dispositivo pueda seguir localizándose correctamente</p>
    </strong>

    <li style="text-align: left;">Restablecer los ajustes de fábrica</li>
    <p style="text-align: left;"> 
      Presione dos veces el botón de función; escuchará un pitido. Luego, presione rápidamente el botón de función cuatro veces y, en la quinta pulsación, manténgalo presionado hasta escuchar un sonido de timbre. Ahora el dispositivo se ha restablecido.
    </p>
  </ol>

  <h3>  Preguntas frecuentes  </h3>
  <h4>No puedo conectar mi dispositivo con la aplicación Find My Device de Google
Se recomiendan las siguientes acciones:  </h4>
<ol>
  <li style="text-align: left;">Reinicie el Bluetooth y la red móvil de su teléfono.
Reinicie el Bluetooth y la red móvil de su teléfono, apague y vuelva a encender el dispositivo y, a continuación, espere a que aparezca la ventana emergente “Wireless tag”.
</li>
  <li style="text-align: left;">Restablezca su dispositivo.Restablezca su dispositivo, apáguelo y vuelva a encenderlo. Luego, espere a que aparezca la ventana emergente “Wireless tag”.
</li>
  <li style="text-align: left;">Reinicie su teléfono e inténtelo de nuevo.
Reinicie su teléfono, apague y vuelva a encender el dispositivo y, a continuación, espere a que aparezca la ventana emergente “Wireless tag”.
</li>
<li style="text-align: left;"> Actualice el software de su teléfono.
  <p>
    Paso 1. Acceda a los ajustes del teléfono y busque “Sistema”</p>
<p>Paso 2. Busque Actualizaciones de software y abra “Actualización del sistema”; luego, compruebe si hay actualizaciones.</p>
<p>Paso 3. Actualice el sistema de su teléfono a la versión más reciente.</p>
</li>
<li style="text-align: left;">Busque los servicios de Google de su teléfono para conectar el dispositivo.
  <p>Paso 1. Acceda a los ajustes del teléfono y busque “Servicios y preferencias de Google”.</p>
<p>Paso 2. Acceda a “Servicios y preferencias de Google” y busque “Todos los servicios”.</p>
<p>Paso 3. Acceda a “Todos los servicios” y busque “Dispositivos conectados y uso compartido”.</p>
<p>Paso 4. Acceda a “Dispositivos” y busque “Dispositivos disponibles cercanos”. Si puede ver “Wireless tag”, haga clic en “Wireless tag” y espere a que aparezca la ventana emergente “Wireless tag”.</p>
<p>Paso 5. Si no puede ver “Wireless tag”, apague y vuelva a encender el dispositivo hasta que aparezca “Wireless tag”. También puede restablecer el dispositivo, apagarlo y volver a encenderlo hasta que aparezca “Wireless tag”. Luego, haga clic en “Wireless tag”, espere a que aparezca la ventana emergente “Wireless tag” y tóquela para conectarse.</p>
</li>
</ol>
<p style="text-align: left; color:#333 "  >Una vez vinculado a una cuenta de Google, el dispositivo queda inaccesible para otros usuarios.</p>
<p style="text-align: left; color:#333 "  >Cuando su objeto esté cerca, puede eliminarlo desde la aplicación. El dispositivo emitirá un sonido de timbre para indicar que se ha eliminado correctamente; después, otras personas podrán utilizarlo.</p>
<p style="text-align: left; color:#333 "  >Cuando su objeto esté fuera del alcance de la conexión de su teléfono y su Locator haya sido eliminado de la aplicación Find My, otras personas no podrán utilizar el dispositivo. Debe restablecer su Locator para que otras personas puedan utilizarlo.</p>

<h3>ADVERTENCIA</h3>
<ol>
  <li> Retire y recicle o deseche inmediatamente las baterías usadas de acuerdo con las normativas locales y manténgalas fuera del alcance de los niños. NO deseche las baterías con la basura doméstica ni las incinere.</li>
  <li>Incluso las baterías usadas pueden causar lesiones graves o la muerte.</li>
  <li>Llame a un centro local de control de intoxicaciones para obtener información sobre el tratamiento.</li>
  <li>Las baterías no recargables no deben recargarse.</li>
  <li>No fuerce la descarga, no recargue, desmonte, caliente por encima de 50 °C/122 °F ni incinere la batería.</li>
  <li>Hacerlo puede provocar lesiones debido a la ventilación, fugas o explosión, lo que puede causar quemaduras químicas. 6. El tipo de batería compatible es CR2032.</li>
  <li>Voltaje nominal de la batería: CC 3 V</li>
  <li>Asegúrese de instalar las baterías correctamente según la polaridad (+ y -). 9. No mezcle baterías nuevas y usadas, ni baterías de diferentes marcas o tipos, como alcalinas, de zinc-carbono o recargables.</li>
  <li>Retire y recicle o deseche inmediatamente las baterías de equipos que no se utilicen durante un período prolongado, de acuerdo con las normativas locales.</li>
  <li> Asegúrese siempre de que el compartimento de la batería esté completamente cerrado. Si el compartimento no se cierra de forma segura, deje de utilizar el producto, retire las baterías y manténgalas fuera del alcance de los niños.</li>
</ol>
<h5>
  <p>Tipo de batería: CR2032. Voltaje de la batería: 3 V.</p>
<p>Manténgala en su embalaje original hasta que esté lista para su uso;</p>
<p>Deseche inmediatamente las baterías usadas y manténgalas fuera del alcance de los niños. NO deseche las baterías con la basura doméstica.</p>
</h5>

<img src="../assets/image_battery.png" class="image_1">

</div>

</template>

<script>
export default {
  name: 'SpanishLanguage',
};
</script>

<style scoped>
.english-container {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 10px;
  margin: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h1, h2,h3,h4,h5 {
  color: #333;
 text-align: left; /* 明确标题左对齐（如果父级未继承） */

}
ul, ol {
  margin-left: 20px;
  padding-left: 15px;
 list-style-type: decimal; /* 强制显示数字编号 */

}
li {
  margin-bottom: 8px;
  text-align: left;
  color: #000000;
}

.image_1 {
  width: 90%; /* 或根据需要调整 */
  height: auto;
  margin-bottom: 10px;
  border-radius: 8px;
}

</style>